"use client"
import { Attribute, LocatorStationsWrapper } from "api";
import { GetPageQuery } from "apollo";
import MapHeaderCharge from "map-feature/charge-stations-map/ChargeStationsMap";
import QuestionListBlockCharge from "pazChargeComponents/Home/QuestionListBlockCharge";
import { BlockRenderer, extractProperty, findProperty } from "utils";
import ContentText from "./ContentText";
import MapDownloadAppChargeBlock from "./MapDownloadAppCharge";

type Props = {
    data: GetPageQuery,
    metadata: Attribute[]
    stations: LocatorStationsWrapper
}

const components = {
    chargingStationsHeader: MapHeaderCharge,
    chareAppBlock: MapDownloadAppChargeBlock,
    chargeQuestionsList: QuestionListBlockCharge,
    contentText: ContentText,
}


function PublicStationsChargePage({ data, metadata, stations }: Props) {

    const pageName = extractProperty(data.page, "pageName")

    return (<>
        {findProperty(data?.page, "blocks")?.blocks?.map(
            // TO DO : HOW TO FIND BLOCK TYPE IN GENERATED GRAPHQL TYPES
            (block: any, index: number) => {
                const sideMenuTitle = block.properties.find(
                    (prop: any) => prop.propertyName === "sideMenuTitle",
                )?.propertyValue?.value
                let addProps;
                if (block.blockType === "chargingStationsHeader") {
                    addProps = {
                        metadata,
                        stations,
                        pageName
                    }
                }
                if (block.blockType === "chargeQuestionsList") {
                    addProps = {
                        noPadding: true
                    }
                }
                if (block) {
                    return (
                        <section key={`${sideMenuTitle}_${index}`} id={sideMenuTitle || `page : ${index.toString()}`}>
                            <BlockRenderer
                                index={index}
                                key={index}
                                blockType={block.blockType}
                                blockData={block}
                                components={components}
                                props={addProps}
                            >
                            </BlockRenderer>
                        </section>
                    )
                }
            },
        )}
    </>);
}

export default PublicStationsChargePage;
